import type { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { SCHEDULE_CONSTANTS } from "../../utils";
import { SHOP_HEADER_H } from "../constant";
import type { MonthlyCalendarRow } from "../../type";

interface LeftColumnProps {
  rowLabelHeader?: string;
  rowLabelDescription?: string;
  headerAction?: ReactNode;
  rows: MonthlyCalendarRow[];
}

export default function LeftColumn({
  rowLabelHeader,
  rowLabelDescription,
  headerAction,
  rows
}: LeftColumnProps) {
  const leftPanelWidth = SCHEDULE_CONSTANTS.LEFT_PANEL_WIDTH;

  // Build ordered list: inject a shop-header sentinel before each new groupKey
  type ListItem =
    | { kind: "shop-header"; groupKey: string }
    | { kind: "row"; row: MonthlyCalendarRow };

  const items: ListItem[] = [];
  let lastGroupKey: string | undefined = undefined;
  for (const row of rows) {
    if (row.groupKey !== undefined && row.groupKey !== lastGroupKey) {
      items.push({ kind: "shop-header", groupKey: row.groupKey });
      lastGroupKey = row.groupKey;
    }
    items.push({ kind: "row", row });
  }

  return (
    <div
      className="aero:flex-shrink-0 aero:flex aero:flex-col aero:h-full aero:border-r aero:border-neutral-300"
      style={{ width: leftPanelWidth }}
    >
      {/* Panel header */}
      <div className="aero:flex-shrink-0 aero:bg-neutral-50 aero:border-b aero:border-neutral-300 aero:py-3 aero:px-5 aero:flex aero:flex-col aero:gap-1 aero:justify-center">
        <div className="aero:flex aero:items-center aero:justify-between">
          <span className="aero:font-bold aero:text-sm aero:text-neutral-500 aero:leading-5">
            {rowLabelHeader}
          </span>
          {headerAction}
        </div>
        {rowLabelDescription && (
          <p className="aero:text-[10px] aero:font-normal aero:text-neutral-500 aero:leading-4">
            {rowLabelDescription}
          </p>
        )}
      </div>

      {/* Scrollable row list */}
      <div className="aero:flex-1 aero:overflow-y-auto aero:overflow-x-hidden">
        {items.map((item, idx) => {
          if (item.kind === "shop-header") {
            return (
              <div
                key={`shop-${item.groupKey}-${idx}`}
                className={cn(
                  "aero:flex aero:items-center aero:px-4 aero:border-b aero:border-neutral-200",
                  "aero:bg-neutral-50"
                )}
                style={{ height: SHOP_HEADER_H }}
              >
                <span className="aero:font-bold aero:text-[12px] aero:leading-[16px] aero:text-neutral-700 aero:truncate">
                  {item.groupKey}
                </span>
              </div>
            );
          }
          return (
            <div
              key={item.row.id}
              className="aero:border-b aero:border-neutral-300 aero:last:border-b-0"
            >
              {item.row.rowCard}
            </div>
          );
        })}
      </div>
    </div>
  );
}
